import request from "../utils/request";

export const getUserinfo = async () => {
    try {
        const response = await request.get("/user/profile", {
        });
        return response.data; // Return the user info data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const getNotifications = async () => {
    try {
        const response = await request.get("/notifications/latest", {
        });
        return response.data; // Return the notifications data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const getListFriends = async () => {
    try {
        const response = await request.get("/profile/friends", {
        });
        return response.data; // Return the list of friends data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const getPendingFriendsRequests = async () => {
    try {
        const response = await request.get("/profile/requests", {
        });
        return response.data; // Return the pending friends requests data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const sendFriendRequest = async (receiverId) => {
    try {
        const response = await request.post("/profile/request", { receiverId });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const acceptFriendRequest = async (requestId) => {
    try {
        const response = await request.post("/profile/accept", { requestId });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const rejectFriendRequest = async (requestId) => {
    try {
        const response = await request.post("/profile/reject", { requestId });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const findUsers = async () => {
    try {
        const response = await request.get("/user/random-users", {
        });
        return response.data; // Return the found users data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
};

export const uploadAvatar = async (formData) => {
    try {
        const response = await request.post("/profile/uploadAvatar", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
};
